import React, { Component } from "react";
import PropTypes from "prop-types";
import Divider from "@material-ui/core/Divider";
import * as Theme from "../../../app/Theme";
import * as HLConst from "../NonVisual/HLConst";
import HLNavBtnDiv from "../Other/HLNavBtnDiv";
import image from "../../../img/boy and girl.jpg";

class HLStep6Form extends Component {
    static propTypes = {
        onPageChange: PropTypes.func,
    };

    static defaultProps = {
        onPageChange: () => console.log("onPageChange"),
    };

    state = {};

    //==================================================================================================================
    //
    //                                              Event Handlers
    //
    //==================================================================================================================

    onPageChange = (pageID) => {
        this.props.onPageChange(pageID);
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    renderTextDiv = () => {
        let textDiv = (
            <div
                style={{
                    ...Theme.textFontStyle,
                    // backgroundColor : Theme.HL_PrimaryColor,
                    // color           : "white",
                    marginLeft: Theme.leftIndent,
                }}
            >
                <p
                    style={{
                        ...Theme.pageHeadingFontStyle,
                        ...Theme.pageHeadingWithBannerStyle,
                    }}
                >
                    {HLConst.step6AreaText1}
                    &nbsp;
                    {/*<span style = {Theme.stepSubTextHeadingFontStyle}>*/}
                    {HLConst.step6AreaText2}
                    {/*</span>*/}
                </p>

                <Divider
                    style={{
                        ...Theme.dividerStyle,
                    }}
                />

                <p>
                    Now with costs known and implementation-related challenges identified, make a final decision about
                    which interventions and activities to focus on.
                </p>

                <ul>
                    <li>
                        Remember that prevention will almost always be more cost-effective than treatment in the long
                        term, so you may want to prioritize prevention interventions
                    </li>
                    <li>
                        Costs and lives saved aren’t the only considerations – also government and organizational
                        priorities, Sphere standards, and other issues may need to be considered
                    </li>
                    <li>You may want to define short-, medium- and long-term priorities</li>
                </ul>

                <p>
                    Return to your completed worksheets and circle activities you have chosen to focus on. Add costed
                    activities to your annual plan and budget.
                </p>

                <div
                    style={{
                        ...Theme.exampleDivStyle,
                    }}
                >
                    <p>
                        <span
                            style={{
                                textDecoration: "underline",
                            }}
                        >
                            For example:
                        </span>
                        &nbsp;Because you decided that increasing coverage of treatment for MAM was outside your control
                        in step 5, you remove it from your list of prioritized interventions (at least for the time
                        being until the situation changes). The second most life-saving intervention, oral antibiotics
                        for pneumonia, is feasible to address through ensuring sufficient supply of antibiotics and
                        training of health care providers and pharmacy staff, and it’s affordable with your proposed
                        budget. This becomes your #1 priority for the coming year.
                    </p>
                </div>
            </div>
        );

        return textDiv;
    };

    render() {
        // const downloadGuideBtn =
        //     <HLDownloadGuideBtn/>;

        const navBtnDiv = (
            <HLNavBtnDiv
                onBackBtnClick={() => this.onPageChange(HLConst.step5Form)}
                onNextBtnClick={() => this.onPageChange(HLConst.step7Form)}
            />
        );

        return (
            <div
                style={{
                    minHeight: window.innerHeight - Theme.HL_FooterOffset, //Theme.HL_FooterPosition,
                }}
            >
                <img
                    style={{
                        width: "calc(100% - 1px)",
                    }}
                    src={image}
                    alt=""
                />

                {this.renderTextDiv()}
                {/*{downloadGuideBtn}*/}
                {navBtnDiv}
            </div>
        );
    }
}

export default HLStep6Form;
